import React from 'react';
import Label from 'components/form/Label/Label';
import { CSPopover } from 'components/Popover/CSPopover';

const LoanEstimatesDisclaimer = props => {
  const { config, handleShowLoanEstimatesDisclaimer } = props;
  let loanEstimatesDisclaimer = null;
  if (config) {
    loanEstimatesDisclaimer =
      config.disclaimers.autoLoans.loanEstimatesDisclaimer;
  }

  if (loanEstimatesDisclaimer) {
    return (
      <CSPopover
        placement={'topRight'}
        arrowPointAtCenter
        ariaLabel={loanEstimatesDisclaimer}
        overlayClassName={'loanEstimatesDisclaimer'}
        onMouseEnter={handleShowLoanEstimatesDisclaimer}
        content={<div>{loanEstimatesDisclaimer}</div>}
      >
        <Label className="text-12 link">*Loan Estimates</Label>
      </CSPopover>
    );
  } else {
    return null;
  }
};

export default LoanEstimatesDisclaimer;
